import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, state } = useLocation();
  const prevPath = useRef(pathname); // memorizza la pagina precedente

  useEffect(() => {
    const isPoliciesPage = pathname.includes('/policies');
    const hasSectionHash = !!state?.hash;

    // 🔸 Esegui scroll solo se stiamo veramente cambiando pagina
    if (pathname !== prevPath.current) {
      // 🔹 Non scrollare subito su Policies se c'è una hash (gestisce già da sé)
      if (!isPoliciesPage || !hasSectionHash) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      // Aggiorna la pagina precedente
      prevPath.current = pathname;
    }
  }, [pathname, state]);

  return null;
}

export default ScrollToTop;
